import useFramerate from "../../../../hooks/useFramerate"
import PrefixedInput from "../../../common/PropertyTools/PrefixedInput"

interface TimingProps {
    /** in seconds; NaN when the selected animations differ ("Mixed") */
    time: number
    name: string
    label: string
    unit: string
    handleOnChange: (e: any) => void
}

/** Shown in frames at 25 / 50 fps, in seconds otherwise — a step is a frame or a tenth. */
const useTimingStep = () => {
    const { framerate } = useFramerate()
    return framerate === 25 || framerate === 50 ? 1 : 0.1
}

/** A time — duration or start offset — in seconds or frames, as the graphic counts time. */
export const TimingInput = ({ time, name, label, unit, handleOnChange }: TimingProps) => {
    const { resultTimeFramerate } = useFramerate()
    const step = useTimingStep()
    const isMixed = !Number.isFinite(time)

    return (
        <PrefixedInput
            name={name}
            value={isMixed ? "" : resultTimeFramerate(time).toString()}
            placeholder={isMixed ? "Mixed" : undefined}
            label={label}
            tooltip={`${label} (${unit})`}
            handleOnChange={handleOnChange}
            min={-99999}
            max={99999}
            step={step}
            error={time < 0}
            endAdornment={unit}
        />
    )
}

/**
 * A change of a time — "move by". It always shows 0: whatever is entered is applied to the
 * animation(s) and the field goes back to 0, so every step of the arrows nudges once more.
 */
export const TimingOffsetInput = ({ time, name, label, unit, handleOnChange }: TimingProps) => {
    const step = useTimingStep()

    return (
        <PrefixedInput
            name={name}
            value={time.toString()}
            label={label}
            tooltip={`${label} (${unit})`}
            handleOnChange={handleOnChange}
            min={-99999}
            max={99999}
            step={step}
            endAdornment={unit}
            resetAfterCommit
        />
    )
}
